<script lang="ts">
  import { _ } from 'svelte-i18n';
  import PlanReportChart from './PlanReportChart.svelte';
  import BreakthroughsTable from './BreakthroughsTable.svelte';
  import { num, signed, durationName } from './format';
  import { fitnessProgress, isStatusReport, metrics } from './report';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  export let report: any;
  export let forUser: string | null = null;
  export let onFlagged: () => void = () => {};
  export let refreshed = 0;

  let metric: 'ftp' | 'hie' | 'pp' = 'ftp';
  $: isStatus = isStatusReport(report);
  $: focus = report?.focus_power;
  $: progress = fitnessProgress(report);
  $: breakthroughItems = report?.breakthroughs?.items ?? [];
</script>

  <section class="mb-6 rounded border border-zinc-200 bg-white p-4">
    <h2 class="text-lg font-semibold mb-3">{isStatus ? $_('report.progress_tab.so_far') : $_('report.progress_tab.progress')}</h2>
    <div class="grid grid-cols-3 gap-3 mb-4">
      {#each progress as p}
        <div class="rounded bg-zinc-50 p-3">
          <div class="text-xs text-zinc-500">{p.label}</div>
          <div class="text-lg font-semibold tabular-nums">{num(p.finish * p.scale, p.scale < 1 ? 1 : 0)} <span class="text-xs font-normal text-zinc-500">{p.unit}</span></div>
          <div class="text-xs tabular-nums {p.finish - p.start > 0 ? 'text-green-600' : 'text-zinc-600'}">{$_('report.progress_tab.from', { values: { change: signed((p.finish - p.start) * p.scale, p.scale < 1 ? 1 : 0), start: num(p.start * p.scale, p.scale < 1 ? 1 : 0) } })}</div>
        </div>
      {/each}
    </div>
    <div class="flex gap-2 mb-2">
      {#each metrics as m}
        <button class="px-3 py-1 rounded-full text-sm border {metric === m.key ? 'bg-zinc-800 text-white border-zinc-800' : 'bg-white text-zinc-600 border-zinc-300'}" aria-pressed={metric === m.key} on:click={() => (metric = m.key)}>{m.label}</button>
      {/each}
    </div>
    <PlanReportChart actual={report.fitness.time_series} predicted={report.fitness.predicted_series} breakthroughs={breakthroughItems} updates={report.plan_updates ?? []} {metric} unit={metric === 'hie' ? 'kJ' : 'W'} scale={metric === 'hie' ? 0.001 : 1} />
    {#if report.plan_updates?.length}
      <p class="text-xs text-zinc-500 mt-2">{$_('report.progress_tab.dashed')}</p>
    {/if}
  </section>

  {#if focus}
    <section class="mb-6 rounded border border-zinc-200 bg-white p-4">
      <h2 class="text-lg font-semibold mb-2">{$_('report.progress_tab.power_goal', { values: { duration: durationName(focus.duration_seconds) } })}</h2>
      <p class="text-sm text-zinc-600">{$_(isStatus ? 'report.progress_tab.goal_line_now' : 'report.progress_tab.goal_line_finish', { values: { start: num(focus.start), finish: num(focus.finish), predicted: num(focus.predicted_at_end), target: num(focus.target?.adjusted ?? focus.target?.original) } })}</p>
    </section>
  {/if}

<BreakthroughsTable {report} {forUser} {onFlagged} {refreshed} />
